import React from 'react';
import Slider from 'react-slick';
import '../../../../styles/WhereToStay.css';
import PropTypes from 'prop-types';

const WhereToStay = ({ data, customClass = '' }) => {
  const { heading, viewAll, listData } = data;

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4.2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 1,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2.8,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div className={`rlWhereToStay ${customClass ? customClass : ''}`}>
      <div className="rlWhereToStay__top">
        {heading && <h3>{heading}</h3>}
        {viewAll && (
          <a className="rlWhereToStay__viewmore" href="https://www.makemytrip.com/hotels/">
            {viewAll}
          </a>
        )}
      </div>
      <div className="rlWhereToStaySlider">
        <Slider {...settings}>
          {listData &&
            listData.length > 0 &&
            listData.map(({ id, imageUrl, review, price, hotelName, address, dwebUrl }) => (
              <div key={id} className="rlWhereToStaySlider__item">
                <a href={dwebUrl}>
                  <div className="rlWhereToStaySlider__itemDesc">
                    {imageUrl && (
                      <div className="rlWhereToStaySlider__itemImg">
                        {review && <span className="rlWhereToStaySlider__item--tag">{review}</span>}
                        <img loading="lazy" src={imageUrl} alt="" />
                      </div>
                    )}
                    <div className="rlWhereToStaySlider__dtl">
                      {price && (
                        <p className="appendBottom10 makeFlex end">
                          <span className="font16 blackText">₹{price}</span>{' '}
                          <span className="font10 greyText appendLeft5">per night</span>
                        </p>
                      )}
                      {hotelName && (
                        <p style={{ color: '#4A4A4A' }} className="font12">
                          {hotelName}
                        </p>
                      )}
                      {address && <p className="font12 greyText">{address}</p>}
                    </div>
                  </div>
                </a>
              </div>
            ))}
        </Slider>
      </div>
    </div>
  );
};

WhereToStay.propTypes = {
  data: PropTypes.object,
  customClass: PropTypes.string
};

export default WhereToStay;
